import React, { useEffect, useState } from "react";
import { MapPin, Briefcase, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { jobs } from "../mock";

const CareersPage = () => {
  const [applied, setApplied] = useState(() => JSON.parse(localStorage.getItem("zoofy_applied") || "[]"));
  useEffect(() => window.scrollTo(0, 0), []);

  const apply = (job) => {
    const next = [...applied, job.id];
    setApplied(next);
    localStorage.setItem("zoofy_applied", JSON.stringify(next));
    toast.success(`Application noted for "${job.title}". Our TA team will reach out!`);
  };

  return (
    <main className="bg-[#050f24] min-h-screen">
      <section className="relative pt-44 pb-20 overflow-hidden">
        <div className="absolute left-1/3 top-10 w-[500px] h-[400px] rounded-full bg-white/8 blur-3xl" />
        <div className="absolute right-0 top-24 w-[400px] h-[400px] rounded-full bg-blue-600/12 blur-3xl" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-white text-sm font-semibold tracking-wide uppercase mb-4">Careers</p>
          <h1 className="text-white text-4xl sm:text-5xl lg:text-[64px] font-bold max-w-3xl leading-[1.06]" style={{ fontFamily: "Archivo, sans-serif" }}>
            Grow where technology meets purpose
          </h1>
          <p className="text-white/70 text-lg leading-relaxed mt-8 max-w-2xl">
            Join 4,500+ technologists serving enterprises across 520+ locations. Learning budgets, fast growth and a
            culture of “serving with love”.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-28">
        <h2 className="text-white text-2xl lg:text-3xl font-bold mb-8" style={{ fontFamily: "Archivo, sans-serif" }}>
          Open roles
        </h2>
        <div className="space-y-4">
          {jobs.map((job) => {
            const isApplied = applied.includes(job.id);
            return (
              <div
                key={job.id}
                className="bg-[#0b2044] border border-white/10 hover:border-white/40 rounded-2xl p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-5 transition-colors"
                data-testid={`job-${job.id}`}
              >
                <div>
                  <h3 className="text-white font-bold text-lg" style={{ fontFamily: "Archivo, sans-serif" }}>{job.title}</h3>
                  <div className="flex flex-wrap items-center gap-x-5 gap-y-1 mt-2 text-white/55 text-sm">
                    <span className="inline-flex items-center gap-1.5"><Briefcase size={14} /> {job.team}</span>
                    <span className="inline-flex items-center gap-1.5"><MapPin size={14} /> {job.location}</span>
                    <span>{job.type}</span>
                  </div>
                </div>
                <button
                  onClick={() => !isApplied && apply(job)}
                  disabled={isApplied}
                  className={`inline-flex items-center gap-2 text-sm font-bold px-6 py-2.5 rounded-full transition-colors flex-shrink-0 ${
                    isApplied
                      ? "bg-white/10 text-white/50 cursor-default"
                      : "bg-white hover:bg-[#d7e3f4] text-[#04122e]"
                  }`}
                >
                  {isApplied ? "Applied" : <>Apply Now <ArrowRight size={15} /></>}
                </button>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default CareersPage;
